































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import addMembersForm from "../components/addMembersForm.vue";
import wizard from "../components/wizard.vue";
import consts from "../consts";
import { validateEmail, validateMembers, getPropertyByKeys } from "../utils";
import { Team, MemberToAdd, User, UserStat } from "../types";
import { deleteTeam } from "@/api.ts";
import axios from "axios";
import moment from "moment";
import { Getter, Action } from "vuex-class";

@Component({
  components: {
    wizard,
    addMembersForm
  },
  filters: {
    moment(date: string) {
      return moment(date).format("YYYY - MM - DD");
    }
  }
})
export default class AddTeam extends Vue {
  @Getter private currentTeamID!: string;
  @Getter private JWT?: string;
  @Getter private currentTeam?: Team;
  @Getter private teamByID!: (id: number) => Team;

  @Action private fetchTeams!: () => any;
  @Action private fetchCurrentTeam!: () => any;
  @Action private fetchCurrentTeamLicenses!: () => any;
  @Action private setCurrentTeam?: any;

  private uploadSuccess: boolean = false;
  private uploadFile: File | null = null;
  private teamName: string = "";
  private newTeamID: any;

  private managers: MemberToAdd[] = [
    {
      name: "",
      email: "",
      role: "manager",
      valid: null
    }
  ];
  private members: MemberToAdd[] = [
    {
      name: "",
      email: "",
      role: "user",
      valid: null
    }
  ];
  private formSubmitted: boolean = false;
  private formReturned: boolean = false;
  private error: boolean = false;
  private errorMessage: string =
    "We're having some trouble connecting and we're working on fixing the issue. Please try again later!";
  private currentPage: number = 0;
  private steps: any[] = this.genSteps();

  private showErrorMessage(forManagers: boolean) {
    if (forManagers) {
      for (let i = 0; i < this.managers.length; i++) {
        if (this.managers[i].valid === false) {
          return true;
        }
      }
    } else {
      for (let i = 0; i < this.members.length; i++) {
        if (this.members[i].valid === false) {
          return true;
        }
      }
    }
    return false;
  }

  private validateManagers() {
    if (this.teamName && this.teamName.length) {
      return (
        this.membersIsEmpty(this.managers) || validateMembers(this.managers)
      );
    }
    return false;
  }

  private validateMembers() {
    return this.membersIsEmpty(this.members) || validateMembers(this.members);
  }

  private membersIsEmpty(members: MemberToAdd[]) {
    if (
      !members.length ||
      (members &&
        members.length === 1 &&
        members[0].name === "" &&
        members[0].email === "")
    ) {
      return true;
    }
    return false;
  }

  private genSteps() {
    let validateManagers = this.validateManagers();
    let validatMembers = validateManagers && this.validateMembers();
    return [
      {
        label: "1. Team Management",
        slot: "page1",
        options: {
          nextDisabled: !validateManagers
        }
      },
      {
        label: "2. Team Members",
        slot: "page2",
        options: {
          nextDisabled: !validatMembers
        }
      },
      {
        label: "3. Last Steps",
        slot: "page3",
        options: {
          nextDisabled: !validatMembers,
          hideActions: this.formSubmitted
        }
      }
    ];
  }

  private handleChange(isManager?: boolean, i?: number) {
    // Form visual validation for email
    let users = this.managers;
    if (!isManager) {
      users = this.members;
    }

    if (users.length && typeof i === "number" && users[i]) {
      let email = users[i].email;
      if (validateEmail(email)) {
        this.$set(users[i], "valid", null);
      } else {
        this.$set(users[i], "valid", false);
      }
    }
    this.steps = this.genSteps();
  }

  private handleUpload(file: File, success: boolean) {
    if (success) {
      this.members = [];
    }
    this.uploadSuccess = success;
    this.uploadFile = file;
    this.handleChange();
  }

  private nextClicked(currentPage: number) {
    if (currentPage === 0) {
      return this.validateManagers();
    } else {
      return this.validateMembers();
    }
  }

  private backClicked(currentPage: number) {
    return true;
  }

  private addManager() {
    this.managers.push({
      name: "",
      email: "",
      role: "manager",
      valid: null
    });
    this.handleChange();
  }

  private removeManager(index: number) {
    this.managers.splice(index, 1);
    this.handleChange();
  }

  private addMember() {
    this.members.push({
      name: "",
      email: "",
      role: "user",
      valid: null
    });
    this.handleChange();
  }

  private removeMember(index: number) {
    this.members.splice(index, 1);
    this.handleChange();
  }

  private addTeam() {
    if (this.validateManagers() && this.validateMembers()) {
      this.formSubmitted = true;
      this.handleChange();
      let users: any = [];
      let myteam: any = null;
      if (!this.membersIsEmpty(this.managers)) {
        for (const manager of this.managers) {
          users.push({
            Name: manager.name,
            Email: manager.email.toLowerCase(),
            Role: manager.role
          });
        }
      }

      if (!this.membersIsEmpty(this.members)) {
        for (const member of this.members) {
          users.push({
            Name: member.name,
            Email: member.email.toLowerCase(),
            Role: member.role
          });
        }
      }
      if (this.currentTeam) {
        myteam = {
          name: this.teamName,
          EnterpriseID: this.currentTeam.EnterpriseID,
          DefaultLicenseID: this.currentTeam.DefaultLicenseID
        };
      }
      console.log("ADD TEAM request");
      axios({
        method: "POST",
        url: consts.serverURL + "team",
        headers: { Authentication: this.JWT },
        data: myteam
      })
        .then(resp => {
          console.log("ADD TEAM", resp.data);
          const newTeam: Team = resp && resp.data;
          this.newTeamID = resp.data.ID;

          // add members through csv api after team created
          if (this.uploadSuccess && this.uploadFile) {
            let formData = new FormData();
            formData.append("file", this.uploadFile);
            axios({
              method: "POST",
              url: consts.serverURL + "team/" + this.newTeamID + "/users/csv",
              headers: {
                Authentication: this.JWT,
                "Content-Type": "multipart/form-data"
              },
              data: formData
            })
              .then(resp2 => {
                console.log("ADD USERS FROM CSV", resp2.data);
                // Refresh
                this.refreshTeamsData();
              })
              .catch(reason => {
                this.deleteTeam(this.newTeamID)
                console.log(reason, reason.response);
                let errormsg = getPropertyByKeys(reason, [
                  "response",
                  "data",
                  "Error"
                ]);
                this.errorMessage = errormsg;
                this.error = true;
                this.formReturned = true;
              });
          } else if (users.length) {
            axios({
              method: "POST",
              url: consts.serverURL + "team/" + this.newTeamID + "/users",
              headers: { Authentication: this.JWT },
              data: users
            })
              .then(resp2 => {
                console.log("ADD USERS", resp2.data);
                // Refresh
                this.refreshTeamsData();
              })
              .catch(reason => {
                this.deleteTeam(this.newTeamID)
                console.log(reason, reason.response);
                let errormsg = getPropertyByKeys(reason, [
                  "response",
                  "data",
                  "Error"
                ]);
                this.errorMessage = errormsg;
                this.error = true;
                this.formReturned = true;
              });
          } else {
            //Refresh
            this.refreshTeamsData();
          }
        })
        .catch(error => {
          console.log(error, error.response);
          /* if (error.response && error.response.status === 403) {
            this.errorMessage = error.response.data.Error;
          } */
          this.errorMessage = error.response.data.Error;
          this.error = true;
          this.formReturned = true;
        });
    }
  }

  private deleteTeam(teamID: string) {
    if (this.JWT) {
      deleteTeam(this.JWT,teamID);
    }
  }

  private async refreshTeamsData() {
    await this.fetchTeams();
    this.setCurrentTeam(this.teamByID(this.newTeamID));
    await this.fetchCurrentTeam();
    await this.fetchCurrentTeamLicenses();
    this.formReturned = true;
  }
}
